/** 本地矢量属性图标按展示名称命名。 */
export function getLocalTypeIconSrc(name: string): string {
    return `/assets/type/${encodeURIComponent(name)}.svg`;
}

/** 本地资源缺失或加载失败时回退一次，避免云端失败后循环请求。 */
export function fallbackTypeIcon(event: Event): void {
    const image = event.currentTarget as HTMLImageElement;
    const fallback = image.dataset.fallbackSrc;
    if (fallback && image.getAttribute("src") !== fallback) {
        image.src = fallback;
    }
}
